import { RowScaffold } from "../../../scaffold";
import { EditorDefns } from "../../../utility";
import { ArsTableCellData, ArsTableRow, ArsTableScaffoldModel } from "../../table";
import { buildArsTableScaffoldModel } from "../../table/functions/buildArsTableScaffoldModel";
import { HEADER_ROW_ID } from "../interface";

/**
 * Builds listing scaffold primitives from backend-calculated ArsTable rows.
 *
 * @param calculatedTableRows - Calculated rows returned by ArsListingCalculation
 * @param editorDefns - Editor definitions for the current listing
 * @returns Scaffold model or null when calculated rows are not usable
 */
export const buildScaffoldFromCalculatedRows = <T>(
  calculatedTableRows: ArsTableRow<T>[],
  editorDefns: EditorDefns<T>,
): ArsTableScaffoldModel<T> | null => {
  const scaffoldModel = buildArsTableScaffoldModel(calculatedTableRows, editorDefns);

  const rows = scaffoldModel.rows.map<RowScaffold<ArsTableCellData<T>>>((row) => {
    const isHeader = row.id === HEADER_ROW_ID || row.type === "header";

    return {
      id: row.id,
      height: row.height,
      rowGroupNumber: isHeader ? 0 : 1,
      rowNumber: row.rowNumber,
      type: isHeader ? "header" : "body",
    };
  });

  return {
    cellData: scaffoldModel.cellData,
    columns: scaffoldModel.columns,
    headerColSpans: scaffoldModel.headerColSpans,
    rows,
  };
};
